import { extractUTMParameters, shareUTMParameters } from '../utils/utm.js';
import { updateGlobalActionProperties } from './globalActionProperties.js';
/**
 * Updates the global action properties with the UTM parameters from the URL. This function should be called once when the application initializes the
 * analytics client.
 *
 * @returns
 */
export function updateUTMParametersFromUrl() {
    if (typeof window === 'undefined')
        return {};
    const { href } = window.location;
    const { type, props: utmParams } = extractUTMParameters(href);
    const hasUtm = Object.keys(utmParams).length > 0;
    if (type === 'url') {
        // Share utm params via a cookie to other apps
        shareUTMParameters(utmParams);
    }
    if (hasUtm) {
        // This will update the global action properties with the utm parameters. We update them here so that we don't have to do this in the track function using the
        // extractUTMParameters function. This way, we can avoid the overhead of parsing the URL for utm parameters on every track call.
        updateGlobalActionProperties(utmParams);
    }
    return utmParams;
}
//# sourceMappingURL=utmActionProperties.js.map